export const calculateViewportUnits = () => {
    document.documentElement.style.setProperty("--vh", `${window.innerHeight * 0.01}px`);
};

export const calculateHeaderSize = () => {
    const header = document.querySelector(".l-header");

    if (!header) {
        return;
    }

    document.documentElement.style.setProperty("--header-height", `${header.offsetHeight}px`);
};

export const scrollToEl = (el, offset = 0, behavior = "smooth") => {
    if (!el) return;

    // ! odkomentovat, ked hlavicka bude znovu sticky
    // const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0
    const headerHeight = 0;

    window.scroll({
        top: el.offsetTop - headerHeight - offset,
        behavior: behavior,
    });
};

// export const scrollToEl = (el, offset = 0, behavior = 'smooth') => {
//     if (!el) return

//     let headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0
//     const elOffsetTop = el.getBoundingClientRect().top + document.documentElement.scrollTop

//     if (document.querySelector('.js-account-nav')) {
//         headerHeight += document.querySelector('.js-account-nav').offsetHeight
//     }

//     console.log({elOffsetTop, headerHeight, offset})

//     window.scroll({
//         top: elOffsetTop - headerHeight - offset,
//         behavior: behavior
//     })
// }
